import "./CoreSkills.scss";

function CoreSkills() {
  return (
    <>
      <h2 className="core-skills-title">Core skills</h2>

      <div className="core-skills">
        <div className="core-skills__category">
          <h3>Frontend</h3>
          <ul>
            <li>React</li>
            <li>TypeScript</li>
            <li>Next.js</li>
            <li>Playwright</li>
            <li>i18next</li>
          </ul>
        </div>

        <div className="core-skills__category">
          <h3>Backend</h3>
          <ul>
            <li>Node.js</li>
            <li>NestJS</li>
            <li>GraphQL</li>
            <li>PostgreSQL</li>
            <li>DynamoDB</li>
            <li>Kafka</li>
          </ul>
        </div>

        <div className="core-skills__category">
          <h3>Cloud and DevOps</h3>
          <ul>
            <li>AWS</li>
            <li>CI/CD</li>
            <li>GitHub Actions</li>
            <li>Infrastructure maintenance</li>
          </ul>
        </div>

        <div className="core-skills__category">
          <h3>AI</h3>
          <ul>
            <li>Anthropic Claude</li>
            <li>Agentic workflows</li>
            <li>LLM integrations</li>
            <li>AI-assisted development</li>
          </ul>
        </div>
      </div>
    </>
  );
}

export { CoreSkills };
